export default __webpack_public_path__ + "static/media/dynamicPages-selected.c38865da.svg";